import React, { useState, useEffect } from "react"
import Dashboard from "./pages/dashboard"
import Login from "./pages/login"
import { Toaster } from "react-hot-toast"
import { BrowserRouter as Router } from "react-router-dom"
import Cookies from "js-cookie"
import { jwtDecode } from "jwt-decode"

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isLoading, setIsLoading] = useState(true) // Loading state
  const [user, setUser] = useState({})

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const urlToken = urlParams.get("accessToken")
    if (urlToken) {
      Cookies.set("token", urlToken, { expires: 1 })
    }

    const cookieToken = Cookies.get("token")
    if (cookieToken) {
      const decoded = jwtDecode(cookieToken)
      if (decoded) {
        setUser(decoded)
      } else {
        console.error("Invalid token or unable to decode.")
      }
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }

    setIsLoading(false) // Mark as loaded after processing
  }, [])

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    )
  }

  return (
    <Router>
      <div className="App">
        {isLoggedIn && !isLoading ? (
          <Dashboard user={user} />
        ) : (
          <Login onLogin={() => setIsLoggedIn(true)} />
        )}
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App
